// Central content for ADK SOLUTIONS — Powering Modern Agriculture

export const COMPANY = {
  name: "ADK SOLUTIONS",
  tagline: "Powering Modern Agriculture",
  phone: "+91 93271 77854",
  phoneRaw: "919327177854",
  whatsapp: "919327177854",
  email: "adksolutions26@gmail.com",
  address: "Shop No 10, 11, Building No: A4, Krishna Residency, NH48, At Po-Kholvad, Ta-Kamrej, Dist-Surat 394190",
  mapEmbed:
    "https://www.google.com/maps?q=Krishna+Residency+NH48+Kholvad+Kamrej+Surat+394190&output=embed",
  socials: {
    facebook: "#",
    instagram: "#",
    youtube: "#",
    linkedin: "#",
  },
};

export const IMAGES = {
  logo:
    "https://customer-assets-jai6qajn.emergentagent.net/job_adk-agri-solutions/artifacts/7h67gtg1_FullLogo.jpg",
  hero:
    "https://images.unsplash.com/photo-1594771804886-a933bb2d609b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyYWwlMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzg0OTA4MTY4fDA&ixlib=rb-4.1.0&q=85",
  fieldAerial:
    "https://images.pexels.com/photos/33851721/pexels-photo-33851721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  farmer:
    "https://images.pexels.com/photos/9368704/pexels-photo-9368704.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cropRows:
    "https://images.pexels.com/photos/33786603/pexels-photo-33786603.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PRODUCTS = [
  {
    slug: "chisel-plough",
    index: "01",
    name: "Chisel Plough",
    short: "Deep tillage that breaks hardpan without disturbing topsoil.",
    image:
      "/img/chisel-plough.jpg",
    overview:
      "The Chisel Plough is designed for deep tillage without disturbing the topsoil. It breaks hardpan layers, improves soil aeration, enhances root development, and allows better water penetration for healthier crops.",
    features: [
      "Heavy-duty steel construction",
      "High-strength replaceable tines",
      "Deep tillage capability",
      "Strong frame design",
      "Low maintenance",
      "Long service life",
    ],
    benefits: [
      "Better soil health",
      "Improved water absorption",
      "Increased crop productivity",
      "Reduced fuel consumption",
    ],
    applications: ["Deep tillage", "Hardpan breaking", "Pre-monsoon field prep"],
    hp: "50–65 HP",
  },
  {
    slug: "vishwakarma-360-land-leveler",
    index: "02",
    name: "360 Degree Land Leveler",
    short: "Perfectly level fields for efficient irrigation and uniform crops.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_adk-agri-solutions/artifacts/iy3wgpt2_images%20%281%29.jpeg",
    overview:
      "The 360 Degree Land Leveler ensures perfectly level fields, improving irrigation efficiency while reducing water loss and increasing crop uniformity.",
    features: [
      "Heavy-duty leveling blade",
      "Strong fabricated frame",
      "Easy tractor attachment",
      "Precision land leveling",
      "Rugged construction",
    ],
    benefits: [
      "Saves irrigation water",
      "Uniform crop growth",
      "Higher yield",
      "Reduced labor costs",
    ],
    applications: ["Field leveling", "Irrigation prep", "Pre-sowing operations"],
    hp: "45–60 HP",
  },
  {
    slug: "adjustable-bund-former",
    index: "03",
    name: "Adjustable Bund Former",
    short: "Accurate field bunds, fast — for smarter water management.",
    image:
      "/img/bund-former.jpg",
    overview:
      "The Bund Former creates accurate field bunds quickly and efficiently, making irrigation management easier while improving water conservation.",
    features: [
      "Adjustable bund size",
      "Heavy-duty construction",
      "Fast field operation",
      "Easy maintenance",
    ],
    benefits: [
      "Better water conservation",
      "Efficient irrigation channels",
      "Rapid field operation",
      "Low upkeep",
    ],
    applications: [
      "Sugarcane fields",
      "Cotton farming",
      "Vegetable cultivation",
      "Irrigation channel preparation",
    ],
    hp: "40–55 HP",
  },
  {
    slug: "hydraulic-reversible-plough",
    index: "04",
    name: "Hydraulic Reversible Plough",
    short: "Continuous soil inversion with hydraulic reversing technology.",
    image:
      "/img/reversible-plough.jpg",
    overview:
      "Designed for efficient soil inversion, the Hydraulic Reversible Plough allows continuous ploughing with hydraulic reversing technology, ensuring better field preparation and increased productivity.",
    features: [
      "Hydraulic reversing system",
      "High-strength steel body",
      "Double-sided ploughing",
      "Heavy-duty bearings",
      "Precision engineering",
    ],
    benefits: [
      "Saves time",
      "Uniform ploughing",
      "Better soil mixing",
      "Fuel efficient",
    ],
    applications: ["Primary tillage", "Soil inversion", "Large-farm operations"],
    hp: "55–75 HP",
  },
  {
    slug: "apogee-laser-land-leveler",
    index: "05",
    name: "APOGEE Laser Land Leveler",
    short: "Laser-guided precision leveling — up to 30% irrigation savings.",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_adk-agri-solutions/artifacts/z3hw0ro6_Sports_Bucket.png",
    overview:
      "The APOGEE Laser Land Leveler uses advanced laser-guided technology to achieve highly accurate land leveling, helping farmers conserve water, improve irrigation efficiency, and maximize crop yields.",
    features: [
      "Laser-guided precision leveling",
      "Automatic hydraulic control",
      "Uniform field leveling",
      "Water-saving technology",
      "Easy operation",
    ],
    benefits: [
      "Saves up to 30% irrigation water",
      "Better seed germination",
      "Uniform crop growth",
      "Increased profitability",
      "Precision farming",
    ],
    applications: ["Precision leveling", "Water conservation", "High-value crops"],
    hp: "50–70 HP",
  },
];

export const WHY_CHOOSE = [
  { icon: "BadgeCheck", title: "Trusted Specialist", desc: "Dedicated agricultural machinery experts you can rely on." },
  { icon: "ShieldCheck", title: "Genuine Products", desc: "100% authentic implements, no compromises." },
  { icon: "Users", title: "Expert Guidance", desc: "Right implement for your soil and crop." },
  { icon: "IndianRupee", title: "Competitive Pricing", desc: "Honest, farmer-first pricing." },
  { icon: "Headphones", title: "After-Sales Support", desc: "Service you can count on, season after season." },
  { icon: "Truck", title: "Fast Delivery", desc: "Quick dispatch across the region." },
  { icon: "Award", title: "Quality Assurance", desc: "Rigorously built, field-proven machinery." },
  { icon: "Heart", title: "Customer Satisfaction", desc: "Long-term relationships over one-time sales." },
];

export const FARMERS_PREFER = [
  { icon: "Sprout", title: "Higher Crop Yield" },
  { icon: "Droplets", title: "Water Conservation" },
  { icon: "Crosshair", title: "Precision Farming" },
  { icon: "Fuel", title: "Fuel Efficiency" },
  { icon: "UserMinus", title: "Reduced Labor" },
  { icon: "Hammer", title: "Durable Construction" },
  { icon: "Wrench", title: "Easy Maintenance" },
  { icon: "Clock", title: "Long Product Life" },
  { icon: "Leaf", title: "Better Soil Health" },
  { icon: "TrendingUp", title: "Higher Profitability" },
];

export const MISSION = [
  "Deliver quality agricultural machinery",
  "Promote precision farming",
  "Improve farmer productivity",
  "Support sustainable agriculture",
  "Build long-term customer relationships",
];

export const TESTIMONIALS = [
  {
    quote:
      "Excellent product quality and outstanding service from ADK SOLUTIONS. Highly recommended.",
    name: "Rameshbhai Patel",
    role: "Farmer, Bharuch",
    rating: 5,
  },
  {
    quote:
      "The APOGEE Laser Land Leveler has significantly reduced our irrigation costs.",
    name: "Jignesh Desai",
    role: "Contractor, Surat",
    rating: 5,
  },
  {
    quote: "Reliable machinery with excellent performance in every season.",
    name: "Maheshbhai Patel",
    role: "Progressive Farmer, Kamrej, Surat",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Why choose ADK SOLUTIONS machinery?",
    a: "ADK SOLUTIONS provides agricultural machinery which are engineered from heavy-duty steel with field-proven designs, delivering durability, precision and low maintenance across Indian farming conditions.",
  },
  {
    q: "What warranty is provided?",
    a: "All implements come with a manufacturer warranty against manufacturing defects. Exact coverage varies by product — our team confirms terms at the time of purchase.",
  },
  {
    q: "Do you provide installation support?",
    a: "Yes. We provide implement fitment guidance, tractor compatibility checks and on-field demonstrations to ensure correct operation from day one.",
  },
  {
    q: "How do I request a demonstration?",
    a: "Use the Request a Quote form, WhatsApp us, or call directly. We schedule on-field demos at your convenience.",
  },
  {
    q: "Which tractor HP is required for each implement?",
    a: "Requirements vary by implement — typically 40–75 HP. Each product page lists a recommended HP range; our experts help match it to your tractor.",
  },
];

export const BLOG = [
  {
    slug: "laser-land-leveling-save-water",
    title: "How Laser Land Leveling Can Save Up to 30% Irrigation Water",
    excerpt:
      "Precision leveling isn't a luxury — it's the fastest ROI most farms can make. Here's why.",
    date: "2026-01-12",
    readTime: "5 min",
    tag: "Precision Farming",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_adk-agri-solutions/artifacts/z3hw0ro6_Sports_Bucket.png",
    body: [
      "Uneven fields waste water. When high spots dry out and low spots waterlog, farmers over-irrigate to compensate — burning water, power and money.",
      "Laser land leveling uses a laser-guided blade with automatic hydraulic control to create a near-perfect grade across the field. The result: water spreads evenly, germination improves, and irrigation cycles shorten.",
      "In practice, growers report irrigation savings of up to 30%, more uniform crop stands, and measurably higher yields. On water-scarce farms, the APOGEE Laser Land Leveler often pays for itself within a few seasons.",
    ],
  },
  {
    slug: "chisel-plough-soil-health",
    title: "Deep Tillage & Soil Health: When to Use a Chisel Plough",
    excerpt:
      "Breaking hardpan without flipping the topsoil keeps your soil biology intact.",
    date: "2026-01-05",
    readTime: "4 min",
    tag: "Soil Health",
    image:
      "/img/chisel-plough.jpg",
    body: [
      "Years of shallow cultivation create a compacted hardpan layer that blocks roots and water. A chisel plough fractures that layer without inverting the soil.",
      "Because the topsoil stays in place, beneficial microbes, moisture and organic matter are preserved while aeration and deep water penetration improve.",
      "Use a chisel plough before the monsoon to open up the profile — roots go deeper, crops handle dry spells better, and long-term soil health improves.",
    ],
  },
  {
    slug: "reversible-plough-efficiency",
    title: "Why Hydraulic Reversible Ploughs Cut Ploughing Time",
    excerpt:
      "Continuous ploughing without dead runs means more acres per litre of diesel.",
    date: "2025-12-28",
    readTime: "3 min",
    tag: "Efficiency",
    image:
      "/img/reversible-plough.jpg",
    body: [
      "Conventional ploughs leave open furrows and dead runs, wasting time and fuel at every turn.",
      "A hydraulic reversible plough flips to plough in both directions continuously, giving a uniform finish with no ridges or gaps.",
      "The payoff: faster field coverage, better soil mixing and lower fuel consumption per acre — ideal for larger holdings and contractors.",
    ],
  },
];

export const GALLERY = [
  { src: PRODUCTS[0].image, label: "Chisel Plough" },
  { src: PRODUCTS[1].image, label: "360 Degree Land Leveler" },
  { src: PRODUCTS[2].image, label: "Adjustable Bund Former" },
  { src: PRODUCTS[3].image, label: "Hydraulic Reversible Plough" },
  { src: PRODUCTS[4].image, label: "APOGEE Laser Land Leveler" },
  { src: IMAGES.hero, label: "Working Tractor" },
  { src: IMAGES.farmer, label: "Farmers at Work" },
  { src: IMAGES.fieldAerial, label: "Agricultural Fields" },
];
